const highlightmatch = {
    highlighted: {
        fontWeight: { value: '{fontWeights.bold}' },
    },
};

export { highlightmatch };
